import { Ref } from 'vue'
import { AppError, CoreRuDict, DictTranslationService, Logger, isAppError, isTrCore } from '@prodcard/core'
import { callErrorToast } from './vueToasters'

const coreTranslationService = new DictTranslationService({ dicts: { ru: CoreRuDict } })

const logger = new Logger('ErrorHandler')

export function getErrorMessageWithoutUid(e: AppError): string {
  if (isTrCore(e.messageWithoutUid)) {
    return coreTranslationService.tr(undefined, e.messageWithoutUid)
  } else {
    return e.messageWithoutUid
  }
}

export async function asyncHandleError<T>(block: () => Promise<T>, loader?: Ref<boolean>): Promise<T> {
  try {
    if (loader) loader.value = true

    return await block()
  } catch (e) {
    callErrorToast(isAppError(e) ? getErrorMessageWithoutUid(e) : 'Неизвестная ошибка')
    throw e
  } finally {
    if (loader) loader.value = false
  }
}

export function handleError<T>(block: () => Promise<T>, loader?: Ref<boolean>) {
  asyncHandleError(block, loader).catch(e => logger.error({}, '<70e5b0a6> Error', { error: e }))
}
